const Logo = ({ url, altText, styles }) => {
  return <img src={url} alt={altText} className={styles} />;
};

export default Logo;
